import Announcements from './sections/Announcements';
import CalendarWidget from './sections/CalendarWidget';

export default function TeacherInsightPanel() {
  return (
    <div className="insight-panel-inner">
      <Announcements />
      <CalendarWidget />
    </div>
  );
}
